<div class="Main-Container">
    <div class="spider-container">        
        <div class="spider-txt-img"></div>
    </div>
    <div class="main-section" *ngIf="isSnapshot">
      <div class="tab-section" [ngClass]="{'search-open': isOpen}">
          <div class="tab-track" [@tabSlide]="useDisplayLandingLayout ? displayCategoryPageIndex : pageIndex">
            <div
              class="tab-box"
              *ngFor="let item of (useDisplayLandingLayout ? visibleDisplayCategoryTabs : visibleTabs); let i = index"
              (click)="useDisplayLandingLayout ? displayCategoryTabClick(item, i) : studyNameclick(item, i)"
            >
              <div class="tab" [ngClass]="{ 'active-tab': (useDisplayLandingLayout ? (displayCategoryPageIndex * visibleCount + i) : (pageIndex * visibleCount + i)) === activeIndex }">
                <!-- <span
                  [title]="item.length > 25 ? (item | titlecase) : ''"
                  [ngClass]="{ 'text-ellipsis': item.length > 25 }"
                >
                  {{ item.length > 25 ? (item | slice:0:25) + '...' : item }}
                </span> -->
                <span class="text-ellipsis" [title]="item">{{ item }}</span>

              </div>
            </div>
          </div>

    <div class="tab-controls-right">
      <ng-container *ngIf="(useDisplayLandingLayout ? totalDisplayCategories : totalSnapshots) > visibleCount">
        <button class="tile-arrow left"
            [disabled]="useDisplayLandingLayout ? !canShowDisplayCategoryPrev : !canShowPrev"
            [ngClass]="{'disabled-arrow': useDisplayLandingLayout ? !canShowDisplayCategoryPrev : !canShowPrev}"
            (click)="useDisplayLandingLayout ? (canShowDisplayCategoryPrev && showDisplayCategoryPrev()) : (canShowPrev && showPrev())"
            aria-label="Previous"
            [attr.aria-disabled]="!canShowPrev">
          <img src="assets/images/arrowslefticon.svg" alt="Previous" />
        </button>
        <button class="tile-arrow right"
            [disabled]="useDisplayLandingLayout ? !canShowDisplayCategoryNext : !canShowNext"
            [ngClass]="{'disabled-arrow': useDisplayLandingLayout ? !canShowDisplayCategoryNext : !canShowNext}"
            (click)="useDisplayLandingLayout ? (canShowDisplayCategoryNext && showDisplayCategoryNext()) : (canShowNext && showNext())"
            aria-label="Next"
            [attr.aria-disabled]="!canShowNext">
          <img src="assets/images/arrowsrighticon.svg" alt="Next" />
        </button>
      </ng-container>
      
        </div>
        <div class="tile-search-container">
            <!-- Search Icon -->
            <button (click)="toggleSearch()" class="search-icon">
              <img src="assets/images/search.svg" alt="Search" />
            </button>

              <!-- Search Bar -->
            <div class="search-bar" [ngClass]="{ 'open': isOpen }">
                <input #searchInput type="text" placeholder="Search snapshot name or type" [(ngModel)]="searchText"/>
                <button (click)="toggleSearch()" class="close-btn">
                  <img src="assets/images/close_btn.svg" alt="Close" class="close-icon" />
                </button>
            </div>

            <div *ngIf="isOpen && searchText" class="search-dropdown">
              <div *ngFor="let snapshot of filteredSnapshots" 
                  class="search-dropdown-item"
                  (click)="selectSnapshot(snapshot)">              
                <span class="search-name" [innerHTML]="highlightText(snapshot.name)"></span> |
                <span class="search-type" [innerHTML]="highlightText(snapshot.type)"></span> |
                <ng-container *ngIf="!snapshot.subSection">
                  <span class="search-section" [innerHTML]="highlightText(snapshot.section)"></span>
                </ng-container>

                <ng-container *ngIf="snapshot.subSection">
                  <span class="search-section" [innerHTML]="combineHighlight(snapshot.section, snapshot.subSection)"></span>
                </ng-container>       
              </div>

              <div *ngIf="filteredSnapshots.length === 0" class="search-no-results">
                No results found
              </div>
            </div>
          </div>
      </div>
      <div class="tiles-holder">
        <ng-container *ngIf="isCustomSnapshotWidgetLibrary; else noSnapshot">

          <!-- New display: Category tab → Bucket header → Section tiles -->
          <ng-container *ngIf="useDisplayLandingLayout">
            <div [ngClass]="'Categ-' + (i+1)" [style.flex-grow]="getTileRowCount(bucketGroup)" *ngFor="let bucketGroup of displayLandingGroups; let i = index">
              <div class="category-title">
                <span class="category-name">{{ bucketGroup.bucketName }}</span>
              </div>

              <div class="tile-container">
                <div class="tiles tile-normal"
                    [ngClass]="{ 'selected-study-tile': isTileForSelectedStudy(tile) }"
                    *ngFor="let tile of bucketGroup.tiles"
                    (click)="onDisplayTileClick(tile)">

               

                  <p class="subsection-text">
                    <span [title]="tile.displayLabel">{{ tile.displayLabel }}</span>
                  </p>
                     <p class="subsection-parent line-clamp" [title]="getDescriptionForDisplayTile(tile)">
                    <span>{{ getDescriptionForDisplayTile(tile) }}</span>
                  </p>
                </div>
              </div>

              <div class="line">
                <svg xmlns="http://www.w3.org/2000/svg" width="1068" height="3" viewBox="0 0 1068 3" fill="none">
                  <path d="M0 1.69922H1068" stroke="#8029B6" stroke-opacity="0.1" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
            </div>
          </ng-container>

          <!-- Legacy display -->
          <ng-container *ngIf="!useDisplayLandingLayout">
            <div [ngClass]="'Categ-' + (i+1)" [style.flex-grow]="getTileRowCount(bucketGroup)" *ngFor="let bucketGroup of displayLandingGroups; let i = index">
              <div class="category-title">
                <span class="category-name">{{ bucketGroup.bucketName }}</span>
              </div>

              <div class="tile-container">
                <div class="tiles tile-normal"
                    [ngClass]="{ 'selected-study-tile': isTileForSelectedStudy(tile) }"
                    *ngFor="let tile of bucketGroup.tiles"
                    (click)="onDisplayTileClick(tile)">

                  <p class="subsection-parent line-clamp" [title]="getDescriptionForDisplayTile(tile)">
                    <span>{{ getDescriptionForDisplayTile(tile) }}</span>
                  </p>

                  <p class="subsection-text">
                    <span [title]="tile.displayLabel">{{ tile.displayLabel }}</span>
                  </p>
                </div>
              </div>

              <div class="line">
                <svg xmlns="http://www.w3.org/2000/svg" width="1068" height="3" viewBox="0 0 1068 3" fill="none">
                  <path d="M0 1.69922H1068" stroke="#8029B6" stroke-opacity="0.1" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
            </div>
          </ng-container>
        </ng-container> 

        <!-- No Snapshot -->
        <ng-template #noSnapshot>
          <div class="no-snapshot-container">
            <h2 class="no-snapshot-title">
              {{ isSuperAdmin ? 'No Widget Configured for this Snapshot' : 'No Widgets Configured for Snapshots' }}
            </h2>
            <p class="no-snapshot-subtext">
              {{ isSuperAdmin
                ? 'Please configure a widget to explore data and insights.'
                : 'Please contact your administrator to configure widgets.' }}
            </p>
          </div>
      </ng-template>
      </div>
    </div>
    <div class="Buttons-container">
        <div class="Config-button" 
             [ngClass]="{'Config-button-snapshort': isSnapshot }" *ngIf="isSuperAdmin" (click)="configuration()">
            <div class="Config-button-txt" [ngClass]="{'Config-button-txt-snapshort': isSnapshot }">Add/Configure</div>
            <div class="Config-button-img-block">
                <div class="Config-button-img"></div>
            </div>
        </div>
        <div class="Output-button" *ngIf="!isSnapshot" (click)="navigateToModule()">
            <div class="Output-button-txt">{{ exploreBtn }}</div>
            <div class="Output-button-img-block">
                <div class="Output-button-img"></div>
            </div>
        </div>
    </div>
</div>